<div class="select-wrapper col-1 d-flex align-items-center position-relative">
  <select
    #mySelect
    class=""
    [(ngModel)]="selectedStatus"
    (click)="active = !active"
    [ngClass]="active ? 'down' : ''"
  >
    <option [value]="item" *ngFor="let item of selectlist">
      {{ item }}
    </option>
  </select>
  <!-- <app-svg-icon
    *ngIf="active"
    class="active"
    [src]="'./assets/SVGIcons/arrow-down-icon.svg'"
  ></app-svg-icon> -->
  <app-svg *ngIf="active" id="dropdownBasic6" iconType="UpArrow">
    </app-svg>
    <app-svg *ngIf="!active" id="dropdownBasic6" iconType="DownArrow">
    </app-svg>
</div>
